import React from "react";
// import getData from "../../People/Common/getData";
// import List from "../Components/List";
// import { Button } from "react-bootstrap";
// import Select from "../../../Components/Select";
// import { Card, Image } from "antd";
// import { Link } from "react-router-dom";
// import { useTranslation } from "react-i18next";
import { TableWrapper } from "../../../assets/css/Custom/StudentStyle";

function Wardens() {
  // const [wardenType, setWardenType] = useState(3);
  // const { t } = useTranslation();
  // const [response] = getData(`/warden?type=${wardenType}`, [wardenType]);
  return (
    <div>
      <center>
        {/* <Button
          style={{
            margin: "2rem",
            backgroundColor: wardenType === 3 ? "red" : "#274187",
          }}
          variant="primary"
          onClick={() => setWardenType(3)}
        >
          {t("c-ward")}
        </Button>

        <Button
          style={{
            margin: "2rem",
            backgroundColor: wardenType === 1 ? "red" : "#274187",
          }}
          variant="primary"
          onClick={() => setWardenType(1)}
        >
          {t("ward")}
        </Button>

        <Button
          style={{
            margin: "2rem",
            backgroundColor: wardenType === 2 ? "red" : "#274187",
          }}
          variant="primary"
          onClick={() => setWardenType(2)}
        >
          {t("ass-ward")}
        </Button> */}

        {/* <List
          section="Wardens"
          people={response}
          error={error}
          showProfile={0}
        /> */}
        <div className="row">
          {/* {wardenType !== 1 &&  response
            ? response.map((value) => {
                console.log(value);
                return (
                  <Card
                    hoverable
                    className="mx-auto mt-5"
                    style={{ width: 240 }}
                    cover={
                      <Image
                        src={"null"}
                        fallback="data:image/png;base64,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"
                      />
                    }
                  >
                    <Link
                      to={"/people/profile/" + value.user_id}
                      className="text-primary"
                    >
                      <center>
                        <b>{value.hostel_id} </b>
                      </center>
                    </Link>
                    <p className="text-center">
                      {value.post}
                      <br />
                      {value.email ? (
                        <a href={"mailto:" + value.email} target="_blank" rel="noreferrer">
                          <i className="fad fa-envelope fa-2x"></i>
                        </a>
                      ) : null}
                    </p>
                  </Card>
                );
              })
            : 
            <TableWrapper>
        <table className="table">
          <thead>
            <tr id="headRow">
              <th>Sr. No</th>
              <th>Postion</th>
              <th>Name</th>
              <th>Contact No.</th>
              <th>Email ID</th>
            </tr>
          </thead>
          <tr>
            <td data-column="Sr. No">1</td>
            <td data-column="Postion">Chief Warden</td>
            <td data-column="Name">Prof. Nigam Prakash </td>
            <td data-column="Contact No.">9973771555</td>
            <td data-column="Email ID">chiefwarden@nitjsr.ac.in , nigamprakash@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">2</td>
            <td data-column="Postion">Warden I/C (Boys) </td>
            <td data-column="Name">Dr. Laljee Prasad  </td>
            <td data-column="Contact No.">9470144092</td>
            <td data-column="Email ID">wardenic.boys@nitjsr.ac.in , lprasad.me@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">3</td>
            <td data-column="Postion">Warden I/C (Girls)</td>
            <td data-column="Name">Dr. Madhu Singh</td>
            <td data-column="Contact No.">9431724528</td>
            <td data-column="Email ID">wardenic.girls@nitjsr.ac.in , madhu.ee@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">4</td>
            <td data-column="Postion">Warden , Hostel A</td>
            <td data-column="Name">Dr. Poulami Maji</td>
            <td data-column="Contact No.">8617638634</td>
            <td data-column="Email ID">warden.a@nitjsr.ac.in , poulami.met@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">5</td>
            <td data-column="Postion">Warden , Hostel A</td>
            <td data-column="Name">Dr. Moumita Mondal </td>
            <td data-column="Contact No.">7541013198</td>
            <td data-column="Email ID">warden2.a@nitjsr.ac.in ,moumita.chem@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">6</td>
            <td data-column="Postion">Warden , Hostel B</td>
            <td data-column="Name">Dr. Neha Agnihotri</td>
            <td data-column="Contact No.">8933873665</td>
            <td data-column="Email ID">warden.b@nitjsr.ac.in , neha.phy@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">7</td>
            <td data-column="Postion">Warden , Hostel B</td>
            <td data-column="Name">Dr. Mayuri Baruah</td>
            <td data-column="Contact No.">9678434693</td>
            <td data-column="Email ID">warden2.b@nitjsr.ac.in , mayuri.prod@nitjsr.ac.in</td>
          </tr>

          <tr>
            <td data-column="Sr. No">8</td>
            <td data-column="Postion">Warden, Hostel C</td>
            <td data-column="Name">Dr. Akanksha Shukla </td>
            <td data-column="Contact No.">9910519158</td>
            <td data-column="Email ID">warden.c@nitjsr.ac.in , ashukla.hum@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">9</td>
            <td data-column="Postion">Warden ,Hostel C</td>
            <td data-column="Name">Dr. Shwati Sudha</td>
            <td data-column="Contact No.">9162728686</td>
            <td data-column="Email ID">warden2.c@nitjsr.ac.in , ssudha.hum@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">10</td>
            <td data-column="Postion">Warden , Hostel D</td>
            <td data-column="Name">Dr. Seeram Madhuri</td>
            <td data-column="Contact No.">8309942434</td>
            <td data-column="Email ID">warden.d@nitjsr.ac.in , smadhuri.ce@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">11</td>
            <td data-column="Postion">Warden , Hostel D</td>
            <td data-column="Name">Dr. Dulari Hansdah </td>
            <td data-column="Contact No.">9439844294</td>
            <td data-column="Email ID">warden2.d@nitjsr.ac.in , dhansdah.me@nitjsr.ac.in</td>
          </tr><tr>
            <td data-column="Sr. No">12</td>
            <td data-column="Postion">Warden Hostel RLB</td>
            <td data-column="Name">Dr. Kanika Prasad</td>
            <td data-column="Contact No.">8340412698</td>
            <td data-column="Email ID">warden.rlb@nitjsr.ac.in , kprasad.prod@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">13</td>
            <td data-column="Postion">Warden , Hostel AHR </td>
            <td data-column="Name">Dr. Sangeeta Kumari </td>
            <td data-column="Contact No.">8971492831</td>
            <td data-column="Email ID">warden.ambedkar@nitjsr.ac.in , sangeeta.ce@nitjsr.ac.in</td>
          </tr>

          <tr>
            <td data-column="Sr. No">14</td>
            <td data-column="Postion">Warden , Hostel E </td>
            <td data-column="Name">Dr. Somenath Mondal </td>
            <td data-column="Contact No.">9064006324</td>
            <td data-column="Email ID">warden.e@nitjsr.ac.in , smondal.ce@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">15</td>
            <td data-column="Postion">Warden , Hostel F </td>
            <td data-column="Name">Dr. Chandrashekhar Azad </td>
            <td data-column="Contact No.">9430148516</td>
            <td data-column="Email ID">warden.f@nitjsr.ac.in , csazad.ca@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">16</td>
            <td data-column="Postion">Warden , Hostel G</td>
            <td data-column="Name">Dr. Raj Nandkeolyar</td>
            <td data-column="Contact No.">7837181319</td>
            <td data-column="Email ID">warden.g@nitjsr.ac.in , nandkeolyar.math@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">17</td>
            <td data-column="Postion">Warden , Hostel H</td>
            <td data-column="Name">Dr. Deepak Kumar </td>
            <td data-column="Contact No.">9102794520</td>
            <td data-column="Email ID">warden.h@nitjsr.ac.in , deepak.me@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">18</td>
            <td data-column="Postion">Warden , Hostel I</td>
            <td data-column="Name">Dr. Jitendra Kumar</td>
            <td data-column="Contact No.">75794828895</td>
            <td data-column="Email ID">warden.i@nitjsr.ac.in , jitendra.ee@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">19</td>
            <td data-column="Postion">Warden , Hostel I</td>
            <td data-column="Name">Dr. Dinesh Kumar</td>
            <td data-column="Contact No.">9084932611</td>
            <td data-column="Email ID">warden2.i@nitjsr.ac.in , dinesh.prod@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">20</td>
            <td data-column="Postion">Warden , Hostel J</td>
            <td data-column="Name">Dr. Vineet Sahoo</td>
            <td data-column="Contact No.">8917418799</td>
            <td data-column="Email ID">warden.j@nitjsr.ac.in , vsahoo.me@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">21</td>
            <td data-column="Postion">Warden , Hostel J</td>
            <td data-column="Name">Dr. Subhadeep Metya</td>
            <td data-column="Contact No.">8910690990</td>
            <td data-column="Email ID">warden2.j@nitjsr.ac.in , smetya.ce@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">22</td>
            <td data-column="Postion">Warden , Hostel K</td>
            <td data-column="Name">Dr. Om Hari Gupta</td>
            <td data-column="Contact No.">9455414453</td>
            <td data-column="Email ID">warden2.k@nitjsr.ac.in , omhari.ee@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">23</td>
            <td data-column="Postion">Warden , Hostel K</td>
            <td data-column="Name">Dr. Kunal Singh</td>
            <td data-column="Contact No.">7985201453</td>
            <td data-column="Email ID">warden2.k@nitjsr.ac.in , kunal.ece@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">24</td>
            <td data-column="Postion">Assistant SG-II Office of the Chief </td>
            <td data-column="Name">Mr. Arun Kumar Pandit</td>
            <td data-column="Contact No.">9955833605</td>
            <td data-column="Email ID">arun.fa@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">25</td>
            <td data-column="Postion">Supervisor , Hostels A&B</td>
            <td data-column="Name">Mrs. Boby Banerjee</td>
            <td data-column="Contact No.">834055126</td>
            <td data-column="Email ID">bbanerjee@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">26</td>
            <td data-column="Postion">Supervisor , Hostels C&D</td>
            <td data-column="Name">Mrs. Kanak Kumari</td>
            <td data-column="Contact No.">9006808277</td>
            <td data-column="Email ID"> -- </td>
          </tr>
          <tr>
            <td data-column="Sr. No">27</td>
            <td data-column="Postion">Supervisor , Hostels RLB & AHR </td>
            <td data-column="Name">Mrs. Sumitra Pradhan</td>
            <td data-column="Contact No.">9431786763</td>
            <td data-column="Email ID">warden.i@nitjsr.ac.in , jitendra.ee@nitjsr.ac.in</td>
          </tr>
          
          <tr>
            <td data-column="Sr. No">28</td>
            <td data-column="Postion">Supervisor , Hostels E,F,G&H</td>
            <td data-column="Name">Mr. Jagdish Singh</td>
            <td data-column="Contact No.">9133359767</td>
            <td data-column="Email ID">jagdish@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">29</td>
            <td data-column="Postion">Supervisor , Hostel I</td>
            <td data-column="Name">Mr. Surya Narayan</td>
            <td data-column="Contact No.">8603194011</td>
            <td data-column="Email ID">snyadav@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">30</td>
            <td data-column="Postion">Supervisor , Hostel J</td>
            <td data-column="Name">Mr. Chaman Lal </td>
            <td data-column="Contact No.">8521614611</td>
            <td data-column="Email ID">chamanlal@nitjsr.ac.in</td>
          </tr>
          <tr>
            <td data-column="Sr. No">31</td>
            <td data-column="Postion">Supervisor , Hostel K</td>
            <td data-column="Name">Mr. Urmilesh Jha</td>
            <td data-column="Contact No.">7209579395</td>
            <td data-column="Email ID">urmilesh@nitjsr.ac.in</td>
          </tr>
          
        </table>
      </TableWrapper>
            } */}
          <TableWrapper>
            <br />
            <table className="table">
              <thead>
                <tr id="headRow">
                  <th>Sr. No</th>
                  <th>Postion</th>
                  <th>Name</th>
                  <th>Contact No.</th>
                  <th>Email ID</th>
                </tr>
              </thead>
              <tr>
                <td data-column="Sr. No">1</td>
                <td data-column="Postion">Chief Warden</td>
                <td data-column="Name">Dr. Laljee Prasad</td>
                <td data-column="Contact No.">9470144092</td>
                <td data-column="Email ID">chiefwarden@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">2</td>
                <td data-column="Postion">Warden I/C (Boys) </td>
                <td data-column="Name">Dr. Arvind Kumar Patel </td>
                <td data-column="Contact No.">8878732337</td>
                <td data-column="Email ID">wardenic.boys@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">3</td>
                <td data-column="Postion">Warden I/C (Girls)</td>
                <td data-column="Name">Dr. Kanika Prasad</td>
                <td data-column="Contact No.">8340412698</td>
                <td data-column="Email ID">wardenic.girls@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">4</td>
                <td data-column="Postion">Warden , Hostel-A</td>
                <td data-column="Name">Dr. Suravi Pal</td>
                <td data-column="Contact No.">8787747113</td>
                <td data-column="Email ID">warden.a@nitjsr.ac.in</td>
              </tr>
              {/* <tr>
                <td data-column="Sr. No">5</td>
                <td data-column="Postion">Warden , Hostel A</td>
                <td data-column="Name">Dr. Moumita Mondal </td>
                <td data-column="Contact No.">7541013198</td>
                <td data-column="Email ID">
                  warden2.a@nitjsr.ac.in ,moumita.chem@nitjsr.ac.in
                </td>
              </tr> */}
              {/* <tr>
                <td data-column="Sr. No">6</td>
                <td data-column="Postion">Warden , Hostel B</td>
                <td data-column="Name">Dr. Neha Agnihotri</td>
                <td data-column="Contact No.">8933873665</td>
                <td data-column="Email ID">
                  warden.b@nitjsr.ac.in , neha.phy@nitjsr.ac.in
                </td>
              </tr> */}
              <tr>
                <td data-column="Sr. No">5</td>
                <td data-column="Postion">Warden , Hostel-B</td>
                <td data-column="Name">Dr. Anushree Dutta</td>
                <td data-column="Contact No.">8017265397</td>
                <td data-column="Email ID">warden.b@nitjsr.ac.in</td>
              </tr>

              <tr>
                <td data-column="Sr. No">6</td>
                <td data-column="Postion">Warden, Hostel-C</td>
                <td data-column="Name">Dr. Dulari Hansdah </td>
                <td data-column="Contact No.">9439844294</td>
                <td data-column="Email ID">warden.c@nitjsr.ac.in</td>
              </tr>
              {/* <tr>
                <td data-column="Sr. No">9</td>
                <td data-column="Postion">Warden ,Hostel C</td>
                <td data-column="Name">Dr. Shwati Sudha</td>
                <td data-column="Contact No.">9162728686</td>
                <td data-column="Email ID">
                  warden2.c@nitjsr.ac.in , ssudha.hum@nitjsr.ac.in
                </td>
              </tr> */}
              <tr>
                <td data-column="Sr. No">7</td>
                <td data-column="Postion">Warden , Hostel-D</td>
                <td data-column="Name">Dr. Debshri Swargiary</td>
                <td data-column="Contact No.">9064849473</td>
                <td data-column="Email ID">warden.d@nitjsr.ac.in</td>
              </tr>
              {/* <tr>
                <td data-column="Sr. No">11</td>
                <td data-column="Postion">Warden , Hostel D</td>
                <td data-column="Name">Dr. Dulari Hansdah </td>
                <td data-column="Contact No.">9439844294</td>
                <td data-column="Email ID">
                  warden2.d@nitjsr.ac.in , dhansdah.me@nitjsr.ac.in
                </td>
              </tr> */}
              <tr>
                <td data-column="Sr. No">8</td>
                <td data-column="Postion">Warden Hostel-RLB</td>
                <td data-column="Name">Dr. Shubham Tripathi</td>
                <td data-column="Contact No.">8054415367</td>
                <td data-column="Email ID">warden.rlb@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">9</td>
                <td data-column="Postion">Warden , Hostel-AHR </td>
                <td data-column="Name">Dr. Sangeeta Kumari </td>
                <td data-column="Contact No.">8971492831</td>
                <td data-column="Email ID">warden.ambedkar@nitjsr.ac.in</td>
              </tr>

              <tr>
                <td data-column="Sr. No">10</td>
                <td data-column="Postion">Warden , Hostel-E </td>
                <td data-column="Name">Dr. B. Ramachandra Reddy </td>
                <td data-column="Contact No.">9479639634</td>
                <td data-column="Email ID">warden.e@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">11</td>
                <td data-column="Postion">Warden , Hostel-F </td>
                <td data-column="Name">Dr. Simanta Kumar Samal</td>
                <td data-column="Contact No.">8280295647</td>
                <td data-column="Email ID">warden.f@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">12</td>
                <td data-column="Postion">Warden , Hostel-G</td>
                <td data-column="Name">Dr. Ram Krishna</td>
                <td data-column="Contact No.">6207429787</td>
                <td data-column="Email ID">warden.g@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">13</td>
                <td data-column="Postion">Warden , Hostel-H</td>
                <td data-column="Name">Dr. Amit Kumar </td>
                <td data-column="Contact No.">8317069217</td>
                <td data-column="Email ID">warden.h@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">14</td>
                <td data-column="Postion">Warden , Hostel-I</td>
                <td data-column="Name">Dr. Arjun Kumar</td>
                <td data-column="Contact No.">8127059284</td>
                <td data-column="Email ID">warden.i@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">15</td>
                <td data-column="Postion">Warden , Hostel-I</td>
                <td data-column="Name">Dr. Dinesh Kumar</td>
                <td data-column="Contact No.">9990742787</td>
                <td data-column="Email ID">warden2.i@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">16</td>
                <td data-column="Postion">Warden , Hostel-J</td>
                <td data-column="Name">Dr. Rinku Kumar Gouda</td>
                <td data-column="Contact No.">8895642312</td>
                <td data-column="Email ID">warden.j@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">17</td>
                <td data-column="Postion">Warden , Hostel-J</td>
                <td data-column="Name">Dr. Jitesh Pradhan</td>
                <td data-column="Contact No.">9589633179</td>
                <td data-column="Email ID">warden2.j@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">18</td>
                <td data-column="Postion">Warden , Hostel-K</td>
                <td data-column="Name">Dr. Sankar Kumar Roy</td>
                <td data-column="Contact No.">8910961429</td>
                <td data-column="Email ID">warden.k@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">19</td>
                <td data-column="Postion">Warden , Hostel-K</td>
                <td data-column="Name">Dr. Arvind Kumar Prajapati</td>
                <td data-column="Contact No.">7607276799</td>
                <td data-column="Email ID">warden2.k@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">20</td>
                <td data-column="Postion">Warden , New Boys Hostel</td>
                <td data-column="Name">Dr. Binay Kumar</td>
                <td data-column="Contact No.">8293812519</td>
                <td data-column="Email ID"></td>
              </tr>
              {/* <tr>
                <td data-column="Sr. No">20</td>
                <td data-column="Postion">
                  Assistant SG-II Office of the Chief{" "}
                </td>
                <td data-column="Name">Mr. Arun Kumar Pandit</td>
                <td data-column="Contact No.">9955833605</td>
                <td data-column="Email ID">arun.fa@nitjsr.ac.in</td>
              </tr> */}
              {/* <tr>
                <td data-column="Sr. No">21</td>
                <td data-column="Postion">Supervisor , Hostels-A&B</td>
                <td data-column="Name">Mrs. Boby Banerjee</td>
                <td data-column="Contact No.">834055126</td>
                <td data-column="Email ID">bbanerjee@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">22</td>
                <td data-column="Postion">Supervisor , Hostels-C&D</td>
                <td data-column="Name">Mrs. Kanak Kumari</td>
                <td data-column="Contact No.">9006808277</td>
                <td data-column="Email ID"> kanak.esta@nitjsr.ac.in </td>
              </tr>
              <tr>
                <td data-column="Sr. No">23</td>
                <td data-column="Postion">Supervisor , Hostels-RLB & AHR </td>
                <td data-column="Name">Mrs. Sumitra Pradhan</td>
                <td data-column="Contact No.">9431786763</td>
                <td data-column="Email ID"> sumitra@nitjsr.ac.in</td>
              </tr>

              <tr>
                <td data-column="Sr. No">24</td>
                <td data-column="Postion">Supervisor , Hostels-E,F,G&H</td>
                <td data-column="Name">Mr. Jagdish Singh</td>
                <td data-column="Contact No.">9133359767</td>
                <td data-column="Email ID">jagdish@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">25</td>
                <td data-column="Postion">Supervisor , Hostel-I</td>
                <td data-column="Name">Mr. Surya Narayan Yadav</td>
                <td data-column="Contact No.">8603194011</td>
                <td data-column="Email ID">snyadav@nitjsr.ac.in</td>
              </tr>
              {/* <tr>
                <td data-column="Sr. No">26</td>
                <td data-column="Postion">Supervisor , Hostel J</td>
                <td data-column="Name">Mr. Chaman Lal </td>
                <td data-column="Contact No.">8521614611</td>
                <td data-column="Email ID">chamanlal@nitjsr.ac.in</td>
              </tr> */}
              {/* <tr>
                <td data-column="Sr. No">26</td>
                <td data-column="Postion">Supervisor , Hostel-J</td>
                <td data-column="Name">Mr. Dashrath Singh </td>
                <td data-column="Contact No.">9431304828</td>
                <td data-column="Email ID">dashrath.esta@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">27</td>
                <td data-column="Postion">Supervisor , Hostel-K</td>
                <td data-column="Name">Mr. Urmilesh Jha</td>
                <td data-column="Contact No.">7209579395</td>
                <td data-column="Email ID">urmilesh@nitjsr.ac.in</td>
              </tr> */}
              <tr>
                <td data-column="Sr. No">21</td>
                <td data-column="Postion">Supervisor , Hostels-A</td>
                <td data-column="Name">Mrs. Seema Devi</td>
                <td data-column="Contact No.">6207362023</td>
                <td data-column="Email ID">hostel.a@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">22</td>
                <td data-column="Postion">Supervisor , Hostels-B</td>
                <td data-column="Name">Mrs. Seema Devi</td>
                <td data-column="Contact No.">6207362023</td>
                <td data-column="Email ID">hostel.b@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">23</td>
                <td data-column="Postion">Supervisor , Hostels-C</td>
                <td data-column="Name">Mrs. Puja Kumari</td>
                <td data-column="Contact No.">8092777565</td>
                <td data-column="Email ID"> hostel.c@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">24</td>
                <td data-column="Postion">Supervisor , Hostels-D</td>
                <td data-column="Name">Mrs. Puja Kumari</td>
                <td data-column="Contact No.">8092777565</td>
                <td data-column="Email ID">hostel.d@nitjsr.ac.in </td>
              </tr>
              <tr>
                <td data-column="Sr. No">25</td>
                <td data-column="Postion">Supervisor , Hostels-RLB</td>
                <td data-column="Name">Mrs. Punam Singh</td>
                <td data-column="Contact No.">6207564721</td>
                <td data-column="Email ID"> hostel.rlb@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">26</td>
                <td data-column="Postion">Supervisor , Hostels-AHR </td>
                <td data-column="Name">Mrs. Punam Singh</td>
                <td data-column="Contact No.">6207564721</td>
                <td data-column="Email ID">hostel.ahr@nitjsr.ac.in</td>
              </tr>

              <tr>
                <td data-column="Sr. No">27</td>
                <td data-column="Postion">Supervisor , Hostels-E</td>
                <td data-column="Name">Mr. Vinay Kumar Ojha</td>
                <td data-column="Contact No.">8053535872</td>
                <td data-column="Email ID">hostel.e@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">28</td>
                <td data-column="Postion">Supervisor , Hostel-F</td>
                <td data-column="Name">Mr. Baghrai Hansda</td>
                <td data-column="Contact No.">9893986602</td>
                <td data-column="Email ID">hostel.f@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">29</td>
                <td data-column="Postion">Supervisor , Hostel-G</td>
                <td data-column="Name">Mr. Baghrai Hansda</td>
                <td data-column="Contact No.">9893986602</td>
                <td data-column="Email ID">hostelg@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">30</td>
                <td data-column="Postion">Supervisor , Hostels-H</td>
                <td data-column="Name">Mr. Vinay Kumar Ojha</td>
                <td data-column="Contact No.">8053535872</td>
                <td data-column="Email ID">hostel.h@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">31</td>
                <td data-column="Postion">Supervisor , Hostel-I</td>
                <td data-column="Name">Mr. Mukesh Kumar Tyagi </td>
                <td data-column="Contact No.">7258891467</td>
                <td data-column="Email ID">hostel.i@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">32</td>
                <td data-column="Postion">Supervisor , Hostel-J</td>
                <td data-column="Name">Mr. Santosh Kumar Singh </td>
                <td data-column="Contact No.">7004114283</td>
                <td data-column="Email ID">hostel.j@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">33</td>
                <td data-column="Postion">Supervisor , Hostel-K</td>
                <td data-column="Name">Mr. Mukesh Kumar</td>
                <td data-column="Contact No.">8351927920</td>
                <td data-column="Email ID">hostel.k@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">34</td>
                <td data-column="Postion">
                  Assistant, SG-II Chief Warden Office
                </td>
                <td data-column="Name">Mrs. Boby Banerjee</td>
                <td data-column="Contact No.">8340555126</td>
                <td data-column="Email ID">cwo@nitjsr.ac.in</td>
              </tr>
              <tr>
                <td data-column="Sr. No">35</td>
                <td data-column="Postion">
                  Executive Assistant Chief Warden Office
                </td>
                <td data-column="Name">Mr. Rohit Seth</td>
                <td data-column="Contact No.">7505882291</td>
                <td data-column="Email ID">oo.chiefwarden@nitjsr.ac.in</td>
              </tr>
            </table>
          </TableWrapper>
        </div>
      </center>
    </div>
  );
}

export default Wardens;
